export default "__VITE_ASSET__BEU_vHSh__"